import { useReducer } from 'react';
import requestReducer, { initialState } from 'services/reducers/requestReducer';
import { RequestStatus } from 'services/reducers/types';
import { userService } from 'services/api';
import type { UseDownloadLicenseRequest } from './types';

const useDownloadLicenseRequest = (): UseDownloadLicenseRequest => {
  const [state, dispatch] = useReducer(requestReducer, initialState);

  const downloadLicense = (songId: string) => {
    dispatch({
      type: RequestStatus.Loading,
      payload: null,
    });

    userService
      .downloadSongLicensePDF(songId)
      .then((response) => {
        dispatch({
          type: RequestStatus.Success,
          payload: {
            response,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: RequestStatus.Error,
          payload: {
            error,
          },
        });
      });
  };

  // @ts-ignore
  return [state.loading, state.response, state.error, downloadLicense];
};

export default useDownloadLicenseRequest;
